export class VchalanDetail {
  public CHID!: number;
  public CH_NO!: string;
  public CH_DATE!: string;
  public CN_NO!: string;
  public CN_DATE!: string;
  public CN_CRCODE!: string;
  public CN_CNCODE!: string;
  public CN_STATION!: string;
  public CN_PKG!: number;
  public CN_ACTWT!: number;
  public CN_FRTMODE!: string;
  public CN_STATUS!: string;
  public CREATEDBY_USERID!: Number;
  public UPDATEDBY_USERID!: Number;
  public CREATED_DATE!: Date;
  public UPDATED_DATE!: Date;
  public IS_ACTIVE!: boolean;
}
